import {
  Font,
  StyleSheet,
} from "@react-pdf/renderer";

import fontBold from "../../../src/assets/font/Inter_28pt-Bold.ttf";
import fontMedium from "../../../src/assets/font/Inter_28pt-Medium.ttf";
import fontRegular from "../../../src/assets/font/Inter_28pt-Regular.ttf";
export const fonts = () => {
  Font.register({
    family: "Inter",
    fonts: [
      { src: fontBold, fontWeight: 800 },
      { src: fontMedium, fontWeight: 700 },
      { src: fontRegular, fontWeight: 400 },
    ],
  });
};

export const reportStyles = StyleSheet.create({
  page: {
    padding: 10,
    flexDirection: "column",
    backgroundColor: "#fff",
    fontSize: "12px",
    fontFamily: "Inter",
    fontWeight: "600",
    paddingBottom: 27,
    // fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
  },
  Text: {
    wordWrap: "breakWord",
    whiteSpace: "normal",
    textWrap: "auto",
    wordBreak: "break-word",
    flexWrap: "wrap",
  },
  pdfHeader: {
    display: "flex",
    flexDirection: "row",
    borderBottom: "1px solid #aaa",
  },
  PdfLogo: {
    width: "25%",
    height:100,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "10px",
    borderRight: "1px solid #aaa",
    // borderRadius: "5px",
  },

  Logo: {
  
    height:"90%",
    width:"90%",
    objectFit:"contain",
  },

  HeaderDescription: {
    // backgroundColor: "#ebebeb",
    paddingVertical: "16px",
    width: "70%",
    marginLeft: "15px",
    borderRadius: "5px",
  },
  HeaderHeading: {
    textTransform: "capitalize",
    fontSize: "14px",
    paddingBottom: "10px",
   
    marginBottom: "8px",
    fontWeight: "700",
  },
  HeaderLocation: {
    fontSize: "10px",
    display: "flex",
    alignItems: "center",
    gap: "10px",
    flexDirection: "row",
  },
  pdfHeaderTable: {
    padding: "5px",
    display: "flex",
    flexWrap:"wrap",
    flexDirection: "row",
    marginTop: "5px",
    borderBottom: "1px solid #bcbcbc", 
    borderTop: "1px solid #bcbcbc", 
    gap:"10px"
  },
  pdfHeaderBox: {
    display: "flex",
    flexDirection: "row",
    gap: "5px",
    fontSize: "8px",
    width:"25%",
    padding: "2px 5px",
  },

  pdfHeaderTableBx: {
    flex:1,
    flexBasis:0,
    flexGrow:1,
    fontSize: "8px",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  HeaderTableBxWrap: {
    display: "flex",
    flexDirection: "row",
    gap: "5px",
    
  },
  RightBorder: {
    borderRight: "1px solid #000",
  },
  PaddingRight: {
    paddingRight: "10px",
  },
  PaddingLeft: {
    paddingLeft: "10px",
  },
  PaddingHorizontal: {
    paddingHorizontal: "10px",
  },
  TextBold:{
  fontWeight: "800",
  },
  TextTwelve:{
    fontSize: "12px",
  },
  TextNine:{
    fontSize: "9px",
  },
  TextTen:{
    fontSize: "10px",
  },
  TextPrimary:{
    color: "#0A1D56", 
  },
  TextGrey:{
    color: "#7d7d7d", 
  },
  gap:{
    height:"10px",
  },

  pdfHeaderTableHeadingwrapper: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between"
  },
  pdfHeaderTableHeading: {
    paddingTop: "5px",
    fontSize: "14px",
    fontWeight: "700",
  },
  pdfHeaderSubHeading: {
    paddingBottom: "5px",
    fontSize: "11px",
    fontWeight: "600",
  },
  ReportTh: {
    marginTop: "5px",
    borderTop: "0.5px solid #ccc",
    borderBottom: "0.5px solid #ccc",
    borderLeft: "0.5px solid #ccc",
    borderRight: "0.5px solid #ccc",
    display: "flex",
    flexDirection: "row",
  },
  ReportTd: {
    borderBottom: "0.5px solid #ccc",
    borderLeft: "0.5px solid #ccc",
    borderRight: "0.5px solid #ccc",
    display: "flex",
    flexDirection: "row",
    break: 'false',

  },
  ReportHeaderCell: {
    fontSize: "5px",
    padding: "2px",
    textAlign: "center",
    fontWeight: "700",
    textTransform:"uppercase",
  },
  ReportDetailsCell: {
    fontSize: "8px",
    padding: "2px",
    textAlign: "center",
    fontWeight: "700",
  },
  ReportRowSpan: {
    fontSize: "5px",
    textAlign: "center",
    fontWeight: "700",
  },
  ReportTdCell: {
    fontSize: "5px",
    padding: "3px 2px",
  },
  ReportHeaderFlex: {
    display: "flex",
    flexDirection: "row",
  },
  ReportEarningColsSpan: {
    padding: "2px",
    width: "12.5%",
    height: "100%",
  },
  ReportDeductionColsSpan: {
    padding: "2px",
    width: "16.6666666%",
  },
  pdfSummaryBox:{
    backgroundColor: "#eaefff",
    fontSize: "10px",
    padding: "10px",
    borderRadius: "8px",
    marginVertical: "15px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    gap: "10px",
  },

  pdfSalaryOverview:{
    borderTop: "1px solid #bcbcbc",
    borderBottom: "1px solid #bcbcbc",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  pdfSalaryInfo:{
    width: "48%",
  },
  pdfSalaryOverviewHeading:{
    borderBottom: "1px solid #bcbcbc",
    fontSize: "12px",
    color: "#0A1D56",
    paddingVertical: "10px",
    marginBottom: "10px",
    fontWeight:"800",
    paddingHorizontal: "5px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  pdfSalaryOverviewFooter:{
    borderTop: "1px solid #bcbcbc",
    fontSize: "10px",
    color: "#0A1D56",
    paddingVertical: "10px",
    paddingHorizontal: "5px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: "10px",
    fontWeight:"800",
  },
  pdfSalaryOverviewDetails:{
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    fontSize: "10px",
    paddingVertical: "4px",
    paddingHorizontal: "5px",
  },
  pdfSalaryOverviewAmmount:{
    display: "flex",
    flexDirection: "row",
  },
  pdfSalaryOverviewValue:{
    display: "flex",
    flexDirection: "row",
    alignItems:'center',
    justifyContent:"flex-end",
    width:"60px",
    textAlign:"right",
  },

  pdfSalaryTotal:{
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    paddingVertical: "15px",
    borderBottom: "1px solid #bcbcbc",
    paddingHorizontal: "5px",
  },
  footer:{
    position: 'absolute',
    fontSize: 8,
    bottom: 0,
    left: 0,
    right: 0,
    textAlign: 'center',
    display:"flex",
    flexDirection:"row",
    padding: "10px",
    justifyContent:"space-between",
    color: 'grey',
  },

  ReportHeaderRev:{
    display:'flex',
    flexDirection:"row-reverse",
  },
  pageNumber: {
    position: 'absolute',
    fontSize: 12,
    bottom: 30,
    left: 0,
    right: 0,
    textAlign: 'right',
    color: 'grey',
  },
  downloadTime: {
    position: 'absolute',
    fontSize: 12,
    bottom: 30,
    left: 0,
    right: 0,
    textAlign: 'left',
    color: 'grey',
  },
  pdfSubHeader: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    flexWrap: 'wrap',
  },
  pdfSubHeaderBox:{
    width: "32%",
  },
  ReportMultitable:{
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: "10px",
    flexWrap: 'wrap',
   
  },
  ReportMultibox:{
    width: "32%",
    border: "1px solid #ccc",
    borderBottom: "0px",
    marginBottom: '9px',
    
  },
  ReportMultiboxsubheading:{
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    borderBottom: "1px solid #ccc",
    borderTop: "1px solid #ccc",
    width: "100%",
  },
  ReportMultiboxheading:{
    fontSize: "8px",
    fontWeight: "700",
    padding: "3px",
    color: "#000",
    textAlign: "center",
  },
  ReportMultiboxdetails:{
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  pdfHeaderTableNewEmployee: {
    padding: "5px",
    display: "flex",
    flexWrap:"wrap",
    flexDirection: "row",
  
  },
  pdfHeaderTableNewEmployeeHead: {
    borderBottom: "1px solid #bcbcbc", 
    paddingBottom: "6px",
    // borderTop: "1px solid #bcbcbc", 
    paddingTop: "5px",
    marginTop: "7px",
  },
  NewemployeedeatilsHead: {
    fontSize: "10px",
    fontWeight: "700",
    padding: "3px",
    color: "#000",
    textDecoration: "underline",
  },
  pdfHeaderTableNewbox: {
    flex:1,
    flexBasis:0,
    flexGrow:1,
    fontSize: "8px",
    display: "flex",
    flexDirection: "column",
    gap: "5px",
  },

});